const testimonials = [
  {
    id: 1,
    name: '水野様',
    role: '代表取締役',
    company: 'リユース事業　社員70名',
    area: '八王子市（東京都）',
    stars: 5,
    tag: 'UTM導入',
    tagColor: 'bg-sky-100 text-sky-700',
    quote: '「専門用語を使わずに丁寧に説明してくださり、安心してお任せできました。セキュリティ対策も万全になりました。また複合機の導入で業務効率が改善され非常に感謝してます。」',
    point: '取引先のセキュリティ要求をクリア',
    img: 'https://public.readdy.ai/ai/img_res/16b99270175b3b67365547a79033cb1e.jpg',
  },
  {
    id: 2,
    name: '山田 恵子',
    role: '総務部長',
    company: 'SNS集客支援事業　社員15名',
    area: '横浜市（神奈川県）',
    stars: 5,
    tag: 'UTM導入',
    tagColor: 'bg-sky-100 text-sky-700',
    quote: '「こちらは窓口が一本化されているので、何かあればすぐに相談できるのが本当に助かっています。社内のWi-Fi環境に課題があったのですが、対応も迅速で改善できました。信頼できるパートナーです。」',
    point: '顧客情報を扱う事務所が安心して業務できる環境に',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20business%20woman%20professional%20portrait%20friendly%20smile%20office%20attire%20clean%20background%20confident%20female%20executive%20portrait%20photo%20studio%20white%20background&width=200&height=200&seq=testi02&orientation=squarish',
  },
  {
    id: 3,
    name: '鈴木 義明',
    role: '院長',
    company: '水道設備工事事業　スタッフ5名',
    area: '横須賀市（神奈川県）',
    stars: 5,
    tag: 'UTM導入',
    tagColor: 'bg-sky-100 text-sky-700',
    quote: '「中小企業にちょうどいい提案をしてくれるのが魅力です。過剰な投資を勧められることもなく、本当に必要なものだけを適切な価格で導入できました。セキュリティ対策が万全になりました。」',
    point: '医療機関の個人情報保護体制が大幅強化',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20male%20doctor%20professional%20portrait%20white%20coat%20friendly%20smile%20clean%20background%20confident%20medical%20professional%20portrait%20photo%20studio&width=200&height=200&seq=testi03&orientation=squarish',
  },
  {
    id: 4,
    name: '小林 祐樹',
    role: '経営者',
    company: 'エステ事業　従業員5名',
    area: '大和市（神奈川県）',
    stars: 5,
    tag: 'UTM導入',
    tagColor: 'bg-sky-100 text-sky-700',
    quote: '「エステ店舗のITを全体的にご提案頂きました。最終的にはサイバー攻撃対策を導入しました。個人情報も多く扱うため、情報漏洩に関して安心できてます。サポートも迅速で信頼できます。」',
    point: '不用PC10台を無料で引き取り＋UTM導入につながった',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20young%20business%20man%20professional%20portrait%20casual%20business%20attire%20friendly%20smile%20clean%20background%20confident%20entrepreneur%20portrait%20photo%20studio%20white%20background&width=200&height=200&seq=testi04&orientation=squarish',
  },
];

const TestimonialsSection: React.FC = () => {

  return (
    <section id="testimonials" className="py-24 bg-slate-50">
      <div className="max-w-5xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 leading-tight">
            お客様の声
          </h2>
          <p className="mt-4 text-slate-500 text-base max-w-xl mx-auto leading-relaxed">
            導入企業様よりいただいたご感想の一部をご紹介します。
          </p>
        </div>

        {/* Testimonial cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-white rounded-2xl p-6 border border-slate-100 flex flex-col gap-4 hover:border-sky-200 transition-all duration-200"
            >
              {/* Header */}
              <div className="flex items-start gap-4">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center flex-wrap gap-2 mb-1">
                    <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${t.tagColor}`}>
                      {t.tag}
                    </span>
                    <span className="text-slate-400 text-xs">{t.area}</span>
                  </div>
                  <p className="text-slate-400 text-xs mt-0.5">{t.company}</p>
                </div>
              </div>

              {/* Stars */}
              <div className="flex items-center gap-0.5">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <span key={i} className="text-amber-400 text-sm">★</span>
                ))}
              </div>

              {/* Quote */}
              <div>
                <p className="text-slate-600 text-sm leading-relaxed">
                  {t.quote}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust seal strip */}
        <div className="mt-14 bg-white rounded-2xl border border-slate-100 px-8 py-7">
          <p className="text-center text-slate-400 text-xs font-bold tracking-widest uppercase mb-6">
            安心してご相談いただける理由
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { title: '強引な営業は一切なし', desc: '相談・診断は完全無料。導入を強制することはありません' },
              { title: '地元の顔が見えるサポート', desc: '大和拠点。何かあれば担当者が直接お伺いします' },
              { title: '明確な費用提示', desc: '見積もり前に費用感をご説明。隠れた費用はありません' },
              { title: '導入後も継続サポート', desc: 'お困りごとは電話一本で対応。長期的にお付き合いします' },
            ].map((seal) => (
              <div key={seal.title} className="flex flex-col items-center text-center gap-3">
                <div>
                  <p className="text-slate-700 text-xs font-bold mb-1">{seal.title}</p>
                  <p className="text-slate-400 text-xs leading-relaxed">{seal.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default TestimonialsSection;
